import * as assets from '@assets';
import { CapaQuotationServiceType } from '@generated/graphql';
import { Enum_Action_Button_Enum } from '@hooks/useUserActionLog';

export const ServiceTypeArray: {
  id: CapaQuotationServiceType;
  img: string;
  imgMobile: any;
  serviceName: string;
  knowhow: string;
  knowhowLog?: keyof typeof Enum_Action_Button_Enum;
  caption?: string;
}[] = [
  {
    id: CapaQuotationServiceType.Cnc,
    img: assets.ServiceType_CNC_192,
    imgMobile: assets.ServiceType_CNC_192,
    serviceName: 'CNC 가공',
    knowhow:
      'https://capa.ai/blog/posts/cnc-%EA%B0%80%EA%B3%B5-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EA%B3%B5%EC%9E%91-%EA%B8%B0%EA%B3%84%EB%A5%BC-%ED%86%B5%ED%95%9C-%EC%A0%9C%ED%92%88-%EC%83%9D%EC%82%B0',
    knowhowLog: 'Button_RFQ_CNC_About_ProcessMethod',
    caption: `대부분의 금속 재료를 가공하기 위한 보편적이고 정밀한 방식입니다. 재료를 기계로 깎아서 원하는 현상으로 만듭니다. 플라스틱도 가능합니다.`
  },
  {
    id: CapaQuotationServiceType.Printing,
    img: assets.ServiceType_3D_192,
    imgMobile: assets.ServiceType_3D_192,
    serviceName: '3D 프린팅',
    knowhow:
      'https://capa.ai/blog/posts/3D-%ED%94%84%EB%A6%B0%ED%8C%85-%EA%B0%9C%EB%85%90-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%8B%9C%EC%A0%9C%ED%92%88-%EC%A0%9C%EC%9E%91%EC%9D%98-%EB%AA%A8%EB%93%A0%EA%B2%83',
    knowhowLog: 'Button_RFQ_PRINTING_About_ProcessMethod',
    caption: `재료를 적층해가며 제작하는 가공 방식입니다. 주로 플라스틱 재료를 사용하며 소량의 제작이 필요할 때 적합합니다. 금속 재료를 깎아내며 가공하는 CNC 방식과 대조됩니다.`
  },
  {
    id: CapaQuotationServiceType.Inj,
    img: assets.ServiceType_Molding_192,
    imgMobile: assets.ServiceType_Molding_192,
    serviceName: '금형사출',
    knowhow:
      'https://capa.ai/blog/posts/%EC%82%AC%EC%B6%9C-%EA%B8%88%ED%98%95-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%96%91%EC%82%B0%EC%9D%84-%EC%9C%84%ED%95%9C-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84%EC%99%80-%EC%82%AC%EC%B6%9C-%EC%84%B1%ED%98%95',
    knowhowLog: 'Button_RFQ_INJ_About_ProcessMethod',
    caption: `최소 1,000개 이상의 플라스틱 제품의 대량 생산을 위한 가장 일반적인 방식입니다. 틀(금형)에 융융된 플라스틱 수지를 빠른 속도로 채워 굳힌 뒤 취출합니다. 초기 비용이 높습니다.`
  },
  {
    id: CapaQuotationServiceType.SheetMetal,
    img: assets.ServiceType_Sheetmetal_192,
    imgMobile: assets.ServiceType_Sheetmetal_192,
    serviceName: '판금 가공',
    knowhow:
      'https://capa.ai/blog/posts/%ED%8C%90%EA%B8%88-%EA%B0%80%EA%B3%B5-%EC%89%BD%EA%B3%A0-%EB%B9%A0%EB%A5%B4%EA%B3%A0-%EC%8B%B8%EA%B2%8C-%EC%83%9D%EC%82%B0%ED%95%98%EB%8A%94-%EB%B2%95%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EC%84%B8',
    knowhowLog: 'Button_RFQ_SHEET_METAL_About_ProcessMethod',
    caption: `금속 판재를 이용하여 제작하는 모든 가공 방식을 말합니다. 판재이므로 자르거나(커팅), 구부리거나(절곡), 큰힘을 주거나(프레스), 붙이는(용접) 방식을 사용합니다.`
  },
  {
    id: CapaQuotationServiceType.Casting,
    img: assets.ServiceType_Cast_192,
    imgMobile: assets.ServiceType_Cast_192,
    serviceName: '주조',
    knowhow:
      'https://capa.ai/blog/posts/%EC%A3%BC%EC%A1%B0%E9%91%84%E9%80%A0-%EB%AC%B8%EC%9E%90-%EB%B0%9C%EB%AA%85-%EC%9D%B4%EC%A0%84%EB%B6%80%ED%84%B0-%EC%82%AC%EC%9A%A9%EB%90%9C-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%9B%90%EC%A1%B0',
    knowhowLog: 'Button_RFQ_CASTING_About_ProcessMethod',
    caption: `철, 알루미늄, 합금 등 금속을 녹여 액체로 만든 후 주형(틀, 거푸집)에 부어 굳히는 가공 방식으로 세공품 또는 복잡한 형상의 부품 제작에 적합합니다.`
  },
  {
    id: CapaQuotationServiceType.Design,
    img: assets.ServiceType_Md_192,
    imgMobile: assets.ServiceType_Md_192,
    serviceName: '디자인/설계',
    knowhow:
      'https://capa.ai/blog/posts/%EC%A0%9C%ED%92%88-%EB%94%94%EC%9E%90%EC%9D%B8%EA%B3%BC-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%B2%AB%EA%B1%B8%EC%9D%8C%EC%9D%84-%EC%8B%9C%EC%9E%91%ED%95%98%EC%84%B8',
    knowhowLog: 'Button_RFQ_DESIGN_About_ProcessMethod',
    caption: `제품 외형에 대해 아이디어 스케치를 바탕을 3D 모델링 제작하는 제품디자인부터, 제품 디자인이 실현될 수 있게 제조성을 고려한 설계를 하는 기구설계와 양산을 위한 시제품 제작까지 요청할 수 있는 서비스로, 도면없이 참고이미지와 설명으로도 견적요청이 가능해요.`
  },
  {
    id: CapaQuotationServiceType.Pcb,
    img: assets.ServiceType_Pcb_192,
    imgMobile: assets.ServiceType_Pcb_192,
    serviceName: '전자회로(PCB)',
    caption:
      '인쇄회로기판으로 구리배선이 가늘게 인쇄된 판으로서 각종 전자 부품들을 전기적으로 연결해주는 부품입니다.',
    knowhow:
      'https://capa.ai/blog/posts/%EC%A0%9C%EC%A1%B0-%EA%B8%B8%EC%9E%A1%EC%9D%B4-pcb%EB%9E%80'
  }
];
